module.exports = __webpack_public_path__ + "images/application/i-warning-red-82fee200.svg";